import classNames from 'classnames'
import { Button, ButtonProps } from '@/atoms/Button'
import { CircleCheckIcon } from '@/atoms/Icons/CircleCheckIcon'
import { ReactFCC } from '@/types/react'

interface CheckInputButtonProps extends Omit<ButtonProps, 'variant'> {
  selected: boolean
  iconClassName?: string
}

export const CheckInputButton: ReactFCC<CheckInputButtonProps> & { Skeleton: ReactFCC } = ({
  children,
  selected,
  className,
  disabled,
  iconClassName,

  ...props
}) => {
  return (
    <Button
      {...props}
      variant="white"
      className={classNames(
        'relative w-72 border-2 hover:!bg-core-gray-100',
        selected ? '!border-oxide' : '!border-transparent outline outline-core-gray-300 outline-1',
        disabled && 'pointer-events-none opacity-50',
        className,
      )}
    >
      {children}
      <CircleCheckIcon
        size={24}
        color1={selected ? 'oxide' : 'core-gray-300'}
        className={classNames('absolute right-1.5 top-1.5', selected ? 'block' : 'hidden', iconClassName)}
      />
    </Button>
  )
}

CheckInputButton.Skeleton = function CheckInputButtonSkeleton() {
  return <Button variant="gray" className="h-[60px] w-72 animate-pulse rounded-lg" />
}
